import { LatestFactDTO } from '../../../dto';
import { PatientFactAndType } from '../../../entity/fact';

export const selectFactFromResponse = (response: LatestFactDTO[] = []): PatientFactAndType[] =>
  response.map(latestFactDTO => ({
    fact: latestFactDTO.patientFact,
    type: latestFactDTO.factType,
  }));
